import type { ReactElement } from 'react';
import React from 'react';
import { TabList, Tab, Tabs, TabBar } from '@construct-kit/core';
import styled from 'styled-components';
import type { AllChannelObjects } from '../model/tsTypes';

export type ChannelSwitcherProps = {
  channels: Array<AllChannelObjects>;
  setSelectedChannel: (channel: AllChannelObjects) => void;
  defaultChannel: AllChannelObjects;
};

const StyledTabBar = styled(TabBar)`
  margin-bottom: 0;
`;

export const ChannelSwitcher = ({
  channels,
  setSelectedChannel,
  defaultChannel,
}: ChannelSwitcherProps): ReactElement => (
  <Tabs
    variant="full-width"
    defaultSelectedTab={channels.findIndex((channel) => channel.id === defaultChannel.id)}
    onSelectedTabChange={(e: { index: number }) => {
      setSelectedChannel(channels[e.index]);
    }}
  >
    <StyledTabBar>
      <TabList>
        {channels.map((channel) => (
          <Tab key={channel.id}>{channel.shortHumanReadable}</Tab>
        ))}
      </TabList>
    </StyledTabBar>
  </Tabs>
);
